import React from "react";
import relatedgrain from "../../Asset/relatedgrain/relatedgrain.png";
import relate from "../../Asset/relatedgrain/relate.png";

const Related = () => {
  return (
    <div className="w-full mt-4 pl-4 md:pl-16">
      <div className="w-full flex justify-between h-full">
        <div className=" w-2/3 h-full flex flex-col justify-end pt-0 sm:pt-0 md:pt-6 xl:pt-32 2xl:pt-52">
          
          <hr className="bg-textColor pt-1 w-11/12 my-7 md:my-5 sm:my-16 "></hr>
          <div className="flex gap-2 md:gap-6 flex-col md:flex-row ">
            <div className=" w-10 h-10 md:w-20 md:h-20">
              <img src={relate} alt="" className="h-full w-full object-cover"/>
            </div>
            <div className="flex flex-col">
              <span className="text-xl sm:text-4xl font-bold text-textColor">Related Products</span>
              <span>Subscribe for hassle free experience</span>
            </div>
          </div>
        </div>
        <div className="w-1/3 h-full">
          <div className="w-full h-full">
            <img src={relatedgrain} alt="img" className="w-full h-full object-cover"/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Related;
